<template>
  <div>
    <NavTop :parentData="this.$route.params.tabBarId" class="navbar">
    </NavTop>
    <!-- 内容 -->
    <div class="organization-container">
      <div class="serializable-ul" v-for="(item,index) in data" :key="index">
        <h4>{{ item.name }}</h4>
        <div class="serializable-li">
          <span v-for="(item1,index1) in item.children" :key="index1" @click="navTo(item1)">{{ item1.name }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import home from '../../api/home.js'

export default {
  data () {
    return {
      // 数据
      data: []
    }
  },
  mounted () {

  },
  created () {
    this.getList(this.$route.params.tabBarId)
  },
  methods: {
    // 获取列表
    getList (id) {
      home.getNav({id})
        .then((res) => {
          console.log(res.data.children)
          for (let i = 0; i < res.data.children.length; i++) {
            if (res.data.children[i].id == 370) {
              this.data = res.data.children[i].children
              console.log(this.data, 'llll')
              return
            }
          }
        })
    },
    // 点击列表跳转
    navTo (item) {
      this.$router.push(item.path + '/' + this.$route.params.tabBarId + '/' + item.id)
    }
  }
}
</script>
<style lang="less" scoped>
.organization-container {
  width: 1200px;
  margin: 0 auto;

  .serializable-ul {
    margin-top: 40px;
    margin-bottom: 20px;

    h4 {
      font-size: 16px;
      font-weight: bold;
      color: #333333;
      margin-bottom: 15px;
      margin-top: 20px;
    }

    .serializable-li {
      display: flex;
      justify-content: start;
      flex-direction: row;
      flex-wrap: wrap;
      column-gap: 22px;

      span {
        height: 54px;
        display: flex;
        align-items: center;
        border: 1px solid #CE8386;
        border-left: 4px solid #9E070E;
        padding: 19px 50px 19px 15px;
        color: #333333;
        font-size: 14px;
        cursor: pointer;
        background: url(../../assets/images/arrow.png) no-repeat;
        background-position: 96%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/humanity/organization.vue